/** Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { createStore, createLogger } from 'vuex';
import appCtx from '@hems/user/src/stores/modules/appCtx';
import device, { DEVICE_ACTION } from '@hems/user/src/stores/modules/device';
import site, { SITE_ACTION } from '@hems/user/src/stores/modules/site';
import storm, { STORM_ACTION } from '@hems/user/src/stores/modules/storm';
import user from '@hems/user/src/stores/modules/user';
import { Helper } from '@hems/util';
import energyManagement from '@hems/util/src/stores/modules/energyManagement';
import toast from '@hems/util/src/stores/modules/toast';
export { DEVICE_ACTION, STORM_ACTION, SITE_ACTION };
export default createStore({
    plugins: Helper.getAppEnv() === 'local' ? [createLogger()] : [],
    modules: { appCtx, user, device, storm, site, energyManagement, toast },
});
